import { GetTokenSilentlyOptions, LogoutOptions } from '@auth0/auth0-react';
import { setAcessToken } from '../redux/reducers/accessTokenSlice';
import { resetUser } from '../redux/reducers/userSlice';
import { store } from '../redux/store';
import { PostHog } from 'posthog-js';
import { throwIfAborted } from './fetchCancellation';

const refreshTokenOrLogout = async (
  getAccessTokenSilently: (options: GetTokenSilentlyOptions) => Promise<string>,
  logout: (options?: LogoutOptions) => Promise<void>,
  posthog: PostHog,
  signal?: AbortSignal,
) => {
  throwIfAborted(signal);
  try {
    const newTkn = await getAccessTokenSilently({ cacheMode: 'off' });
    throwIfAborted(signal);
    store.dispatch(setAcessToken(newTkn));
    return newTkn;
  } catch (_err) {
    throwIfAborted(signal);
    store.dispatch(resetUser());
    posthog.reset();
    logout({ logoutParams: { returnTo: window.location.origin } });
  }
};

export default refreshTokenOrLogout;
